import { observer } from 'mobx-react';
import clsx from 'clsx';
import BulkEditInvitationsStore from '../../Store';
import { ConfirmingDeactivate } from '../../Store/Types';
import { T } from '../../../../../../../../Translations';
import Button from '../../../../../../../Form/Button';
import CheckedInvitations from './CheckedInvitations';

interface Props {
  store: BulkEditInvitationsStore;
  state: ConfirmingDeactivate;
}

function DeactivateConfirmation({ store, state }: Props) {
  return (
    <>
      <h3 className="mb-3 text-xl font-semibold">
        <T kind="Remove Collection Access" />
      </h3>
      <CheckedInvitations state={state} />
      <p
        className={clsx(
          'my-6 rounded border-1 border-solid border-teal-400 bg-teal-500 px-4 py-3',
          'text-sm text-gray-800',
        )}
      >
        <T kind="The selected participants will no longer be able to..." />
      </p>
      <Button
        type="button"
        value="Submit"
        onClick={store.deactivating}
        className={clsx(
          'rounded-md border border-solid border-gray-900 bg-white',
          'py-2.5 px-5 text-sm font-semibold text-gray-900',
        )}
      />
    </>
  );
}

export default observer(DeactivateConfirmation);
